import { render, staticRenderFns } from "./ShipmentPopup.vue?vue&type=template&id=260531d2"
import script from "./ShipmentPopup.vue?vue&type=script&lang=js"
export * from "./ShipmentPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports